import type { EditorInstance, EditorOptions } from "./types.ts";

export type { Formats } from "./formats.ts";
export type {
  BlockWidget,
  EditorEvents,
  EditorPlugin,
  LineStyle,
  PluginApi,
  PluginCommand,
} from "./plugins.ts";
export type {
  CommandGroup,
  EditorCommand,
  EditorInstance,
  EditorOptions,
  ImageHooks,
} from "./types.ts";

/** Which way of writing: Live Markdown, Rich text (symbols hidden) or Plain text. */
export type EditorMode = "live" | "rich" | "plain";

/**
 * Starts an editor inside `container` and resolves once it is ready. The text going in and coming
 * out is Markdown. The heavy part (Lexical) loads the first time a live or rich editor is made,
 * so a page that only ever shows plain text never pays for it.
 */
export async function createEditor(
  container: HTMLElement,
  options: EditorOptions & { mode?: EditorMode },
): Promise<EditorInstance> {
  const { mode = "live", ...rest } = options;
  if (mode === "plain") {
    const { createPlain } = await import("./plain/index.ts");
    return createPlain(container, rest);
  }
  const { createLexicalLive } = await import("./lexical/index.ts");
  return createLexicalLive(container, rest, mode === "rich");
}
